import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { KycQuestionnaireDetailWidget } from "../../widgets/kycQuestionnaire/detail";

export const KycQuestionnaireDetailPage = () => {
  const { _id } = useParams<{ _id: string }>();
  useEffect(() => {
    document.title = "KYC Судалгаа дэлгэрэнгүй";
  }, []);
  return (
    <div className="page">
      <KycQuestionnaireDetailWidget _id={_id} />
    </div>
  );
};
